// const initualState = {
//   token: "",
//   personalDetail: {
//     formRefno: "",
//     title: "Mr",
//     firstname: "test",
//     middleName: "test",
//     surname: "test",
//     maidenName: "tset",
//     ssn: "12345678906",
//     bvn: "123",
//     gender: "M",
//     dateOfBirth: new Date(),
//     placeOfBirth: "test",
//     maritalStatusCode: "MD",
//     nationalityCode: "NG",
//     permanentAddressLocation: "N",
//     permState: "AB",
//     permLga: "EZA",
//     permCountry: "NG",
//     stateOfOrigin: "AB",
//     lgaCode: "EZA",
//     mobilePhone: "12345678901",
//     confirmMobilePhone: "12345678901",
//     permCity: "test",
//     othernames: "test",
//     schemeId: "1",
//   },
//   residence: {
//     permanentAddress: "test",
//     permanentAddress1: "test",
//     permZip: "123",
//     email: "test@gmail.com",
//     confirmEmail: "test@gmail.com",
//     permBox: "123",
//   },
//   employer: {
//     employerType: "BR",
//     employerLocation: "N",
//     employerCode: "",
//     employerCountry: "NG",
//     employerLga: "EZA",
//     employerBusiness: "test",
//     employerPhone: "12345678901",
//     confirmEmployerPhone: "12345678901",
//     employerBox: "123",
//     employerStatecode: "AB",
//     employerStreetName: "test",
//     employerAddress1: "test",
//     employerAddress: "test",
//     employerCity: "test",
//     employerZip: "123",
//     dateOfFirstApointment: new Date(),
//     stateOfPosting: "AB",
//   },
//   nextOfKin: {
//     nokEmailaddress: "test@gmail.com",
//     nokConfirmEmailaddress: "test@gmail.com",
//     nokName: "test",
//     nokGender: "m",
//     nokOthername: "test",
//     nokLocation: "N",
//     nokMobilePhone: "12345678901",
//     nokConfirmMobilePhone: "12345678901",
//     nokBox: "123",
//     nokRelationship: "Wife",
//     nokCountry: "N",
//     nokResidenceHouseNumber: "123",
//     nokLga: "EZA",
//     nokStatecode: "AB",
//     // nokResidenceStreetName: "",
//     nokCity: "test",
//     nokSurname: "test",
//     nokTitle: "Mr",
//     nokZip: "123",
//     nokAddress1: "test",
//     nokAddress: "test",
//   },
//   bankDetails: {
//     bankName: "Access Bank Plc",
//     accountNumber: "123",
//     accountName: "test",
//   },
//   signatureImage: "",
//   pictureImage: "",
//   formImage: "",
//   user: {
//     userName: "",
//     password: "",
//   },
// };

const initualState = {
  token: "",
  personalDetail: {
    formRefno: "",
    title: "",
    firstname: "",
    middleName: "",
    surname: "",
    maidenName: "",
    ssn: "",
    permCountry: "",
    bvn: "",
    gender: "",
    dateOfBirth: "",
    placeOfBirth: "",
    maritalStatusCode: "",
    nationalityCode: "",
    permanentAddressLocation: "N",
    permState: "",
    permLga: "",
    stateOfOrigin: "",
    lgaCode: "",
    mobilePhone: "",
    permCity: "",
    othernames: "",
    schemeId: "1",
  },
  residence: {
    permanentAddress: "",
    permanentAddress1: "",
    permZip: "",
    email: "",
    confirmEmail: "",
    permBox: "",
  },
  employer: {
    employerType: "",
    employerLocation: "",
    employerCountry: "NG",
    employerLga: "",
    employerBusiness: "",
    employerPhone: "",
    employerBox: "",
    employerStatecode: "",
    employerStreetName: "",
    employerAddress1: "",
    employerAddress: "",
    employerCity: "",
    employerZip: "",
    dateOfFirstApointment: "",
    stateOfPosting: "",
  },
  nextOfKin: {
    nokEmailaddress: "",
    nokName: "",
    nokGender: "",
    nokOthername: "",
    nokLocation: "",
    nokMobilePhone: "",
    nokBox: "",
    nokRelationship: "",
    nokCountry: "N",
    nokResidenceHouseNumber: "",
    nokLga: "",
    nokStatecode: "",
    nokCity: "",
    nokSurname: "",
    nokTitle: "",
    nokZip: "",
    nokAddress1: "",
    nokAddress: "",
  },
  bankDetails: {
    bankName: "",
    accountNumber: "",
    accountName: "",
  },
  signatureImage: "",
  pictureImage: "",
  formImage: "",
  user: {
    userName: "",
    password: "",
  },
};

export default (state = initualState, action) => {
  switch (action.type) {
    case "SET_RSA_DUBLICATE_TOKEN":
      return {
        ...state,
        token: action.payload,
      };
    case "SET_RSA_DUBLICATED_PERSONAL_DETAIL_FIELD":
      return {
        ...state,
        personalDetail: { ...state.personalDetail, ...action.payload },
      };
    case "SET_RSA_DUBLICATED_RESIDENCE_FIELD":
      return {
        ...state,
        residence: { ...state.residence, ...action.payload },
      };
    case "SET_RSA_DUBLICATED_EMPLOYER_FIELD":
      return {
        ...state,
        employer: { ...state.employer, ...action.payload },
      };
    case "SET_RSA_DUBLICATED_NEXTOFKIN_FIELD":
      return {
        ...state,
        nextOfKin: { ...state.nextOfKin, ...action.payload },
      };
    case "SET_RSA_DUBLICATED_BANK_DETAILS_FIELD":
      return {
        ...state,
        bankDetails: { ...state.bankDetails, ...action.payload },
      };
    case "SET_RSA_DUBLICATED_SIGNATURE_FIELD":
      return {
        ...state,
        signatureImage: action.payload,
      };
    case "SET_RSA_DUBLICATED_PICTURE_FIELD":
      return {
        ...state,
        pictureImage: action.payload,
      };
    case "SET_RSA_DUBLICATED_CONSENT_FORM_FIELD":
      return {
        ...state,
        formImage: action.payload,
      };
    case "GET_RSA_DUBLICATED_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "RESET_RSA_DUBLICATED_FORM":
      return {
        ...state,
        ...initualState,
      };
    default:
      return state;
  }
};
